import { resolveHomepageSection } from './ls-homepage-sync-runtime.js';

export class LSHomepageSectionSync extends HTMLElement {
  connectedCallback() {
    if (this.started) return;
    this.started = true;
    this.target = this.querySelector('[data-ls-homepage-section-target]');
    this.abortController = new AbortController();
    this.desktopQuery = globalThis.matchMedia?.('(min-width: 990px)');

    if (this.dataset.desktopOnly === 'true' && !this.desktopQuery?.matches) {
      this.onDesktopChange = (event) => {
        if (!event.matches) return;
        this.desktopQuery.removeEventListener?.('change', this.onDesktopChange);
        this.load();
      };
      this.desktopQuery?.addEventListener?.('change', this.onDesktopChange);
      return;
    }
    this.load();
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.desktopQuery?.removeEventListener?.('change', this.onDesktopChange);
  }

  async load() {
    if (this.loading || !this.target) return;
    this.loading = true;
    const { signal } = this.abortController;

    try {
      const { html, sectionId } = await resolveHomepageSection({
        key: this.dataset.sourceSectionKey,
        sourceSectionId: this.dataset.sourceSectionId,
        signal,
      });

      if (this.dataset.controllerUrl) await import(this.dataset.controllerUrl);

      const sourceDocument = new DOMParser().parseFromString(html, 'text/html');
      sourceDocument.querySelectorAll('script, link[rel="stylesheet"]').forEach((element) => element.remove());
      sourceDocument.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
        element.removeAttribute('data-shopify-editor-block');
      });
      sourceDocument.querySelectorAll('[data-shopify-editor-section]').forEach((element) => {
        element.removeAttribute('data-shopify-editor-section');
      });
      const nodes = [...sourceDocument.body.childNodes].map((node) => document.importNode(node, true));
      this.target.replaceChildren(...nodes);
      this.dataset.resolvedSectionId = sectionId;
      delete this.dataset.syncError;
      this.setAttribute('aria-busy', 'false');
      this.hidden = false;
    } catch (error) {
      if (error?.name === 'AbortError') return;
      this.target?.replaceChildren();
      this.setAttribute('aria-busy', 'false');
      this.dataset.syncError = 'true';
      this.hidden = true;
    }
  }
}

if (!customElements.get('ls-homepage-section-sync')) {
  customElements.define('ls-homepage-section-sync', LSHomepageSectionSync);
}
